<template>
	<v-layout id="contact" md-10 class="white" column justify-end style="margin-top: 65px; width: 100%;">
		<v-card class="accent column" style="display: flex; height: 270px; width: 100%; justify-content: center; align-items: center;">
			<div style="width: 95%; max-width: 1200px; margin-left: 5%;">
				<span class="text-xs-left font-weight-bold point7 whiteText">Contact Us</span>
			</div>
			<div class="row point55 whiteText" style="width: 95%; max-width: 1200px; display: flex; justify-content: space-between; margin-top: 20px; margin-left: 5%;">
				<div class="column" style="height: 100%; width: 180px; justify-content: flex-end;">
					<div class="my-2 column" style="justify-content: flex-start">
						<span class="text-xs-left point6 font-weight-semibold">Address:</span>
						<span class="text-xs-left">P.O. Box 29-256<br/>Riccarton 8440<br/>Christchurch<br/>New Zealand</span>
					</div>
				</div>
				<div class="column" style="height: 100%; width: 240px; justify-content: space-around;">
					<div class="my-2 column" style="justify-content: center;">
						<span class="text-xs-left point6">Support Email:</span>
						<span class="text-xs-left"><a target="_blank" style="textDecoration: none; color: #ACF;" href="mailto:mecfs1@gmail.com">mecfs1@gmail.com</a></span>
					</div>
					<div class="my-2 column" style="justify-content: center;">
						<span class="text-xs-left point6">Admin Email:</span>
						<span class="text-xs-left"><a target="_blank" style="textDecoration: none; color: #ACF;" href="mailto:mecfs.canterbury@gmail.com">mecfs.canterbury@gmail.com</a></span>
					</div>
				</div>
				<div class="column" style="height: 100%; width: 220px; justify-content: space-around;">
					<div class="my-2 column" style="justify-content: flex-start">
						<span class="text-xs-left point6 font-weight-semibold">Phone:</span>
						<span class="text-xs-left">03-365-5887</span>
					</div>
					<div class="row" style="display: flex; justify-content: flex-start; align-items: center;">
						<v-img src="./fb-button.png" aspect-ratio="1.0" :contain=true max-width="44px"></v-img>
						<a style="margin-left: 20px; textDecoration: none;" target="_blank" href="https://www.facebook.com/mecfscanterburyinc/">
							<span class="text-xs-left point6 whiteText">Follow Us<br/>On Facebook</span>
						</a>
					</div>
				</div>
			</div>
		</v-card>
	</v-layout>
</template>

<script>
export default {
	name: "Contact"
}
</script>